/* Routine card: hotspots select a product card; arrows step through cards; below
   768px the panel is a bottom sheet opened from a hotspot and closed with its
   button or Escape. Without JS the first card is still shown on desktop. */
(function () {
  var MOBILE = window.matchMedia('(max-width: 767px)');

  function initRoutine(root) {
    if (!root || root.dataset.aqpRoutineInit) return;
    root.dataset.aqpRoutineInit = '1';
    var panel = root.querySelector('[data-aqp-routine-panel]');
    if (!panel) return;
    var cards = panel.querySelectorAll('[data-aqp-routine-card]');
    var hotspots = root.querySelectorAll('[data-aqp-routine-hotspot]');
    var current = 0;
    var opener = null;

    function show(n) {
      if (!cards.length) return;
      current = (n + cards.length) % cards.length;
      cards.forEach(function (c, k) {
        var on = k === current;
        c.classList.toggle('is-active', on);
        c.hidden = !on;
      });
      hotspots.forEach(function (h) {
        var on = parseInt(h.getAttribute('data-aqp-routine-hotspot'), 10) === current;
        h.classList.toggle('is-active', on);
        h.setAttribute('aria-expanded', on && panel.classList.contains('is-open') ? 'true' : 'false');
      });
    }
    function setOpen(open, from) {
      panel.classList.toggle('is-open', open);
      // On mobile the panel is a bottom sheet; on desktop it floats over the scene.
      panel.classList.toggle('is-sheet', open && MOBILE.matches);
      root.classList.toggle('is-panel-open', open);
      if (open) {
        opener = from || null;
        if (MOBILE.matches) {
          var close = panel.querySelector('[data-aqp-routine-close]');
          if (close) close.focus();
        }
      } else if (opener) {
        opener.focus();
        opener = null;
      }
      show(current);
    }

    hotspots.forEach(function (h) {
      h.addEventListener('click', function () {
        var n = parseInt(h.getAttribute('data-aqp-routine-hotspot'), 10) || 0;
        var isOpen = panel.classList.contains('is-open');
        if (isOpen && n === current && !MOBILE.matches) { setOpen(false); return; }
        current = n;
        setOpen(true, h);
      });
    });
    var prev = panel.querySelector('[data-aqp-routine-prev]');
    var next = panel.querySelector('[data-aqp-routine-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    var close = panel.querySelector('[data-aqp-routine-close]');
    if (close) close.addEventListener('click', function () { setOpen(false); });
    panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
    if (MOBILE.addEventListener) {
      MOBILE.addEventListener('change', function () { if (panel.classList.contains('is-sheet')) setOpen(false); });
    }
  }

  function init(scope) { (scope || document).querySelectorAll('[data-aqp-routine]').forEach(initRoutine); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();



/* Slideshow: tabs, dots and arrows select a slide; slides fade; nothing advances on its own.
   Without JS the first slide shows. */
(function () {
  function initSlideshow(root) {
    if (!root || root.dataset.aqpSsInit) return;
    root.dataset.aqpSsInit = '1';
    var slides = root.querySelectorAll('[data-aqp-ss-slide]');
    if (slides.length < 2) return;
    var tabs = root.querySelectorAll('[data-aqp-ss-tab]');
    var dots = root.querySelectorAll('[data-aqp-ss-dot]');
    var current = 0;
    function show(n) {
      current = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === current;
        s.classList.toggle('is-active', on);
        s.hidden = !on;
      });
      tabs.forEach(function (t, k) {
        t.classList.toggle('is-selected', k === current);
        t.setAttribute('aria-selected', k === current ? 'true' : 'false');
      });
      dots.forEach(function (d, k) { d.classList.toggle('is-selected', k === current); });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-aqp-ss-tab'), 10) || 0); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); show(parseInt(t.getAttribute('data-aqp-ss-tab'), 10) || 0); }
      });
    });
    dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-aqp-ss-dot'), 10) || 0); }); });
    var prev = root.querySelector('[data-aqp-ss-prev]');
    var next = root.querySelector('[data-aqp-ss-next]');
    if (prev) prev.addEventListener('click', function () { stop(); show(current - 1); });
    if (next) next.addEventListener('click', function () { stop(); show(current + 1); });
    // Autoplay (reference: 8 s per slide): pauses while hovered, stops for good once a tab, dot or arrow is used.
    var speed = parseInt(root.getAttribute('data-aqp-ss-autoplay') || '0', 10) || 0;
    var timer = null, stopped = false;
    function play() { if (stopped || !speed || timer) return; timer = setInterval(function () { show(current + 1); }, speed); }
    function pause() { if (timer) { clearInterval(timer); timer = null; } }
    function stop() { stopped = true; pause(); }
    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', function () { play(); });
    tabs.forEach(function (t) { t.addEventListener('click', stop); });
    dots.forEach(function (d) { d.addEventListener('click', stop); });
    root.aqpSlideshow = { show: show, stop: stop, play: play, get current() { return current; } };
    play();
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(current - 1); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { show(current + 1); e.preventDefault(); }
    });
    show(0);
  }
  function init(scope) { (scope || document).querySelectorAll('[data-aqp-slideshow]').forEach(initSlideshow); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Aqara image columns: phone scroller bar (hidden when the row does not overflow; thumb follows the scroll). */
(function () {
  function initCols(root) {
    if (!root || root.dataset.aqpColsInit) return;
    root.dataset.aqpColsInit = '1';
    var scroller = root.querySelector('[data-aqp-cols-scroller]');
    var bar = root.querySelector('.aqp-cols__bar, .aqp-videos__bar');
    var thumb = root.querySelector('[data-aqp-cols-thumb]');
    if (!scroller || !bar || !thumb) return;
    var frame = null;
    function update() {
      frame = null;
      var cards = scroller.querySelectorAll('.aqp-cols__col, .aqp-videos__card');
      var full = cards.length ? (cards[cards.length - 1].getBoundingClientRect().right - cards[0].getBoundingClientRect().left) : scroller.scrollWidth;
      var max = scroller.scrollWidth - scroller.clientWidth;
      if (max <= 1 && full <= scroller.clientWidth + 1) { bar.hidden = true; return; }
      bar.hidden = false;
      var w = Math.max(10, (scroller.clientWidth / Math.max(full, scroller.scrollWidth)) * 100);
      var left = max > 1 ? (Math.abs(scroller.scrollLeft) / max) * (100 - w) : 0;
      thumb.style.setProperty('--aqp-thumb-w', w + '%');
      thumb.style.setProperty('--aqp-thumb-x', left + '%');
    }
    function schedule() { if (frame === null) frame = window.requestAnimationFrame(update); }
    scroller.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(scroller);
    update();
  }
  function init(scope) { (scope || document).querySelectorAll('.aqp-cols, .aqp-videos').forEach(initCols); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Aqara video cards: play buttons open the video in a lightbox (privacy-enhanced YouTube embed). */
(function () {
  function initVideos(root) {
    if (!root || root.dataset.aqpVideosInit) return;
    root.dataset.aqpVideosInit = '1';
    var modal = root.querySelector('[data-aqp-video-modal]');
    var frame = root.querySelector('[data-aqp-video-frame]');
    if (!modal || !frame) return;
    var lastFocus = null;
    function close() {
      modal.hidden = true; frame.innerHTML = ''; document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    function open(id, button) {
      if (!id) return;
      lastFocus = button;
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.setAttribute('allowfullscreen', '');
      iframe.title = button.getAttribute('aria-label') || 'Video';
      frame.innerHTML = ''; frame.appendChild(iframe);
      modal.hidden = false; document.body.style.overflow = 'hidden';
      var c = modal.querySelector('[data-aqp-video-close]:not(.aqp-videos__backdrop)'); if (c) c.focus();
    }
    root.querySelectorAll('[data-aqp-video-id]').forEach(function (b) { b.addEventListener('click', function () { open(b.getAttribute('data-aqp-video-id'), b); }); });
    modal.querySelectorAll('[data-aqp-video-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    // a single card sits centred (the reference centres its row); several scroll sideways
    var row = root.querySelector('.aqp-videos__row'); if (row && row.children.length === 1) row.classList.add('is-centred');
  }
  function init(scope) { (scope || document).querySelectorAll('[data-aqp-videos]').forEach(initVideos); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();


/* Aqara look split: nothing interactive beyond links; kept for parity with the section registry. */


/* Aqara hero frames and screen-relative slides: the reference keeps every frame at least as tall as its copy box plus 64px plus the menu height
   (59px from 768px up, 48px on phones), recomputed on resize; the frame otherwise follows the image ratio. */
(function () {
  function menuHeight() { return window.innerWidth >= 768 ? 59 : 48; }
  function fit(frame) {
    var content = frame.querySelector('.aqp-hero__content');
    if (!content) return;
    var h = Math.round(content.getBoundingClientRect().height + 64 + menuHeight());
    frame.style.setProperty('--aqp-hr-minh', h + 'px');
    frame.style.setProperty('--aqp-hr-minh-m', h + 'px');
  }
  function screenVars() {
    var h = window.innerHeight, r = document.documentElement.style;
    r.setProperty('--aqp-screen-full', h + 'px'); r.setProperty('--aqp-screen-three-quarters', (h * 0.75) + 'px'); r.setProperty('--aqp-screen-two-thirds', (h * 0.66) + 'px');
    r.setProperty('--aqp-screen-one-half', (h * 0.5) + 'px'); r.setProperty('--aqp-screen-one-third', (h * 0.33) + 'px'); r.setProperty('--aqp-screen-one-fifth', (h * 0.2) + 'px');
  }
  function fitSlide(slide) {
    var frame = slide.querySelector('.aqp-ss__frame'), content = slide.querySelector('.aqp-ss__content');
    if (!frame || !content) return;
    frame.style.setProperty('--aqp-ss-copy-minh', Math.round(content.getBoundingClientRect().height + 64 + menuHeight()) + 'px');
  }
  function fitAll(scope) { screenVars(); (scope || document).querySelectorAll('.aqp-hero__frame').forEach(fit); (scope || document).querySelectorAll('.aqp-ss--screen .aqp-ss__slide').forEach(fitSlide); }
  var frame = null;
  function schedule() { if (frame === null) frame = window.requestAnimationFrame(function () { frame = null; fitAll(); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { fitAll(); });
  else fitAll();
  window.addEventListener('load', function () { fitAll(); });
  window.addEventListener('resize', schedule);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitAll(); });
  document.addEventListener('shopify:section:load', function (e) { fitAll(e.target); });
})();


/* Aqara commerce surfaces: package / look add-to-cart through the store's cart API (the reference posts items to /cart/add.js, refreshes the cart and opens the drawer), a sticky buy bar that mirrors and presses the product form's own button, and the header cart count. Outcomes are reconciled against an independent cart read whenever a response is missing or unreadable, so a lost response never turns into a silent duplicate add. */
(function () {
  var routes = (window.theme && window.theme.routes) || {};
  var addUrl = (routes.cart_add_url || '/cart/add') + '.js';
  var cartUrl = (routes.cart || '/cart') + '.js';
  var seq = 0;
  function readCart() {
    return fetch(cartUrl, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('cart-read-' + r.status);
      return r.json();
    });
  }
  function lines(cart) {
    var m = {};
    (cart && cart.items || []).forEach(function (i) { m[i.variant_id] = (m[i.variant_id] || 0) + i.quantity; });
    return m;
  }
  function updateBadge(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    document.querySelectorAll('[data-header-cart-count]').forEach(function (el) { el.setAttribute('data-header-cart-count', String(cart.item_count)); el.textContent = String(cart.item_count); });
  }
  function announce(cart) {
    document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
    document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
  }
  function refreshCart() {
    var my = ++seq;
    return readCart().then(function (cart) { if (my === seq) announce(cart); return cart; });
  }
  function openDrawer() {
    var drawer = document.querySelector('[data-drawer="drawer-cart"]');
    var toggle = document.querySelector('[data-drawer-toggle="drawer-cart"]');
    if (!drawer || !toggle) return;
    if (!drawer.classList.contains('drawer--visible') && !drawer.classList.contains('is-open')) toggle.click();
    var tries = 0;
    (function focusClose() {   /* move focus into the dialog once it is visible, so Escape closes it and assistive technology lands inside */
      var close = drawer.querySelector('.drawer__close, [data-drawer-toggle="drawer-cart"]');
      if (drawer.classList.contains('drawer--visible') && close) { close.focus(); return; }
      if (++tries < 20) setTimeout(focusClose, 50);
    })();
  }
  function parse(r) {
    return r.text().then(function (t) {
      var j = null;
      try { j = JSON.parse(t); } catch (e) { j = null; }
      return { ok: r.ok, status: r.status, json: j };
    });
  }
  function addItems(items) {
    return fetch(addUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) }).then(parse);
  }
  function bind(btn) {
    if (btn.dataset.aqpBound) return;
    btn.dataset.aqpBound = '1';
    var msg = function (k, d) { return btn.getAttribute('data-aqp-msg-' + k) || d; };
    btn.addEventListener('click', function (ev) {
      ev.preventDefault();
      var ids = (btn.getAttribute('data-aqp-ids') || '').split(',').filter(Boolean).map(function (id) { return parseInt(id, 10); });
      if (!ids.length || btn.disabled || btn.dataset.aqpPending === '1') return;
      var items = ids.map(function (id) { return { id: id, quantity: 1 }; });
      var host = btn.closest('[data-aqp-bundle], .aqp-l2');
      var err = host && host.querySelector('[data-aqp-error]');
      var live = btn.querySelector('[data-aqp-live]');
      var cartLink = btn.getAttribute('data-aqp-cart-url') || (routes.cart || '/cart');
      function show(text, withLink) {
        if (!err) return;
        err.textContent = '';
        err.appendChild(document.createTextNode(text + ' '));
        if (withLink) { var a = document.createElement('a'); a.href = cartLink; a.textContent = msg('check', 'View cart'); err.appendChild(a); }
        err.hidden = false;
        if (live) live.textContent = text;
      }
      btn.dataset.aqpPending = '1'; btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); btn.classList.remove('is-done', 'is-uncertain');
      if (err) { err.hidden = true; err.textContent = ''; }
      if (live) live.textContent = '';
      var before = null;
      function finish(state, info) {
        btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); btn.dataset.aqpPending = '0';
        if (state === 'success') {
          btn.classList.add('is-done'); if (live) live.textContent = msg('added', 'Added to cart');
          setTimeout(function () { btn.classList.remove('is-done'); }, 1500);
          return refreshCart().then(function () { openDrawer(); }, function () { show(msg('refresh', 'Added to cart. Open the cart to see it.'), true); });
        }
        if (state === 'partial') {
          show(msg('partial', 'Only some of the items could be added. Please check your cart.'), true);
          return refreshCart().then(function () { openDrawer(); }, function () {});
        }
        if (state === 'uncertain') {
          btn.classList.add('is-uncertain');
          show(msg('uncertain', 'We could not confirm whether the items were added. Please check your cart before trying again.'), true);
          return;
        }
        show((info && info.text) || msg('error', 'The items could not be added to the cart. Please try again.'), false);
      }
      function reconcile() {
        if (before === null) return finish('uncertain');
        return readCart().then(function (c) {
          var after = lines(c);
          var all = items.every(function (it) { return (after[it.id] || 0) - (before[it.id] || 0) >= it.quantity; });
          var none = items.every(function (it) { return (after[it.id] || 0) === (before[it.id] || 0); });
          if (all) return finish('success');
          if (none) return finish('error');
          return finish('partial');
        }, function () { return finish('uncertain'); });
      }
      readCart().then(function (c) { before = lines(c); }, function () { before = null; })
        .then(function () { return addItems(items); })
        .then(function (res) {
          if (res.ok && res.json && Array.isArray(res.json.items)) {
            var accepted = {};
            res.json.items.forEach(function (i) { accepted[i.variant_id] = true; });
            var missing = items.filter(function (it) { return !accepted[it.id]; });
            return finish(missing.length ? 'partial' : 'success');
          }
          if (res.json && (res.json.description || res.json.message)) return finish('error', { text: res.json.description || res.json.message });
          return reconcile();
        }, function () { return reconcile(); })
        .catch(function () { finish('uncertain'); });
    });
  }
  function stickyBar() {
    var bar = document.querySelector('[data-aqp-stickybar]');
    if (!bar || bar.dataset.aqpBound) return;
    bar.dataset.aqpBound = '1';
    var submit = document.querySelector('.product__submit');
    var mainBtn = document.querySelector('.product__submit .btn--add-to-cart');
    var priceEl = bar.querySelector('[data-aqp-stickybar-price]');
    var addBtn = bar.querySelector('[data-aqp-stickybar-add]');
    var nav = document.querySelector('.aqp-subnav');
    var priceBlock = document.querySelector('[data-price-wrapper] .product__price, .product__block__price .product__price');
    function sync() {
      if (!mainBtn) return;
      var txt = mainBtn.querySelector('[data-add-to-cart-text]');
      var price = priceBlock || mainBtn.querySelector('[data-button-price]');
      if (txt) addBtn.textContent = txt.textContent.trim();
      if (price && priceEl) priceEl.textContent = price.textContent.trim();
      addBtn.disabled = !!mainBtn.disabled;
    }
    function update() {
      if (!submit) return;
      var top = nav ? nav.getBoundingClientRect().height : 0;
      var rect = (mainBtn || submit).getBoundingClientRect();
      bar.hidden = rect.bottom > top + 24 && rect.top < window.innerHeight - 48;
    }
    var pending = false, release = null;
    function formBusy() { return !!mainBtn && (mainBtn.classList.contains('loading') || mainBtn.getAttribute('aria-busy') === 'true' || mainBtn.disabled); }
    addBtn.addEventListener('click', function () {
      if (!mainBtn || pending || formBusy()) return;   /* one press per in-flight form submission: a double click never submits twice */
      pending = true; addBtn.setAttribute('aria-busy', 'true');
      mainBtn.click();
      clearTimeout(release); release = setTimeout(function () { pending = false; addBtn.removeAttribute('aria-busy'); }, 12000);
      var poll = setInterval(function () { if (!formBusy()) { clearInterval(poll); clearTimeout(release); setTimeout(function () { pending = false; addBtn.removeAttribute('aria-busy'); }, 250); } }, 100);
    });
    if (mainBtn && window.MutationObserver) new MutationObserver(sync).observe(mainBtn, { subtree: true, childList: true, characterData: true, attributes: true });
    if (priceBlock && window.MutationObserver) new MutationObserver(sync).observe(priceBlock, { subtree: true, childList: true, characterData: true });
    sync(); update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }
  function track(section) {
    if (section.dataset.aqpTrackBound) return;
    section.dataset.aqpTrackBound = '1';
    var row = section.querySelector('[data-aqp-row]'), bar = section.querySelector('[data-aqp-track]'), thumb = section.querySelector('[data-aqp-thumb]');
    if (!row || !bar || !thumb || section.classList.contains('aqp-bundle--shell')) return;
    function update() {
      var max = row.scrollWidth - row.clientWidth;
      if (max <= 1) { bar.hidden = true; return; }
      bar.hidden = false;
      var w = Math.max(10, (row.clientWidth / row.scrollWidth) * 100);
      var left = (Math.abs(row.scrollLeft) / max) * (100 - w);
      thumb.style.setProperty('--aqp-thumb-w', w + '%'); thumb.style.setProperty('--aqp-thumb-x', left + '%');
    }
    row.addEventListener('scroll', update, { passive: true }); window.addEventListener('resize', update); update();
  }
  function init(scope) {
    (scope || document).querySelectorAll('[data-aqp-add]').forEach(bind);
    (scope || document).querySelectorAll('[data-aqp-bundle]').forEach(track);
    stickyBar();
  }
  if (!document.documentElement.dataset.aqpCartBadge) {
    document.documentElement.dataset.aqpCartBadge = '1';
    document.addEventListener('theme:cart:change', function (e) { updateBadge(e.detail && e.detail.cart); });
    /* The theme's product form announces a successful add with theme:cart:popdown and expects its stock header to
       render a notification; this store's header renders none, so after a short grace period the cart drawer is
       opened instead, giving the form and the sticky bar the same visible confirmation as the package button. */
    document.addEventListener('theme:cart:popdown', function () {
      setTimeout(function () {
        var wrap = document.querySelector('[data-product-add-popdown-wrapper]');
        var shown = wrap && wrap.textContent.trim() !== '' && getComputedStyle(wrap).visibility !== 'hidden';
        var onCartPage = !!document.querySelector('[data-ajax-disable]');
        if (!shown && !onCartPage) openDrawer();
      }, 1200);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
